import { Divider, Input, Switch } from 'antd'
import { useState } from 'react'
import { sparqlFilterTypes } from 'Services/WeaverUtils'

StringFilter = ({ onOk, isSwitchable = true }) ->

  [filterType, setFilterType] = useState(sparqlFilterTypes.CONTAINS)
  [val, setVal] = useState(undefined)

  <>
    <h5>Text filter</h5>
    <Divider style={{ margin: '0 0 10px 0' }} />
    <Input
      data-testid="table-string-filter-search-input"
      placeholder="Search"
      onChange={({ target: { value } }) ->
        onOk(filterType, value)
        setVal(value)
      }
    />
    {
      if isSwitchable
        <Switch
          data-testid="table-string-filter-switch"
          checkedChildren="contains"
          unCheckedChildren="exact"
          defaultChecked
          onChange={(checked) ->
            if checked
              setFilterType(sparqlFilterTypes.CONTAINS)
            else
              setFilterType(sparqlFilterTypes.EXACT)
            onOk(filterType, val)
          }
          style={{
            marginTop: 10
          }}
        />
      else
        <div />
    }
  </>

export default StringFilter
